import {
  COMBINED_REGEX,
  EMAIL_REGEX,
  PHONE_REGEX,
  URL_REGEX,
} from './VisitSummary.const';

export const replaceWithLinks = (text: string) => {
  const parts = text.split(COMBINED_REGEX);
  return parts.map((part: any, index: any) => {
    if (PHONE_REGEX.test(part)) {
      return (
        <a href={`tel:${part}`} key={index}>
          {part}
        </a>
      );
    } else if (URL_REGEX.test(part)) {
      if (
        !(
          part.toLowerCase().startsWith('http://') ||
          part.toLowerCase().startsWith('https://')
        )
      ) {
        part = `http://${part}`;
      }
      return (
        <a href={part} target="_blank" rel="noopener noreferrer" key={index}>
          {part}
        </a>
      );
    } else if (EMAIL_REGEX.test(part)) {
      return (
        <a href={`mailto:${part}`} key={index}>
          {part}
        </a>
      );
    } else {
      return part;
    }
  });
};
